import {MarkdownRenderer} from '@github-ui/copilot-markdown'
import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {clsx} from 'clsx'
import styles from './CopilotMessageBubble.module.css'

interface CopilotMessageBubbleProps {
  markdown: string
}

export function CopilotMessageBubble({markdown}: CopilotMessageBubbleProps) {
  return <MarkdownRenderer className={styles.text} markdown={markdown} />
}

export function CopilotMessageContainer({children}: {children: React.ReactNode}) {
  return <div className={styles.container}>{children}</div>
}

export function CopilotMessageLoading() {
  return (
    <div className={styles.container}>
      <div className={clsx(styles.text, styles.loadingText)}>
        <LoadingSkeleton variant="rounded" height="sm" width="100%" />
        <LoadingSkeleton variant="rounded" height="sm" width="100%" />
        <LoadingSkeleton variant="rounded" height="sm" width="70%" />
      </div>
    </div>
  )
}
